import { RequiredTranslationsTemplate } from '.'

const pl: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Polski',
  },
  home: {
    title: 'OSTRZEŻENIE O PRODUKCIE - ROCKRIDER XC500S',
    description:
      'Dziękujemy za zakup roweru górskiego ROCKRIDER XC500S (MTB). Znaleźliśmy potencjalny słaby punkt w jego przednim widelcu. Tylko niektóre rowery są wadliwe. Proszę wprowadzić 30 cyfr numeru identyfikacyjnego roweru, aby sprawdzić, czy Państwa rower jest objęty tym wycofaniem:',
    form: {
      title: 'Proszę wprowadzić następujące informacje:',
      fields: {
        serialNumber: 'Numer identyfikacyjny',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        email: 'E-mail',
        phone: 'Telefon',
        country: 'Kraj',
        submit: 'Aby zweryfikować',
        choose: 'Wybierać...',
      },
      errors: {
        requiredField: 'To pole jest wymagane',
        unknownSerialNumber: 'Nieznany numer seryjny',
        provide6Numbers: 'Należy pamiętać, że wymagane jest podanie 6 cyfr',
      },
      confirmations: {
        good: {
          title: 'Twój rower nie jest zagrożony',
          p1: 'W takim przypadku informujemy, że Państwa rower nie jest objęty tym wycofaniem. Prosimy nadal cieszyć się jazdą na rowerze.',
          p2: 'Przepraszamy za wszelkie powstałe niedogodności,',
          p3: 'Z poważaniem,',
          p4: 'Ekipa Decathlon',
        },
        defective: {
          title: 'Państwa rower niestety posiada usterkę.',
          p1: 'Prosimy o natychmiastowe zaprzestanie użytkowania tego roweru i skontaktowanie się z najbliższym sklepem Decathlon w celu wymiany widelca.',
          p2: 'Prosimy wziąć pod uwagę, że w trakcie naprawy mogą Państwo nie być w stanie korzystać ze swojego roweru przez kilka dni. Zapewniamy, że zrobimy wszystko, co w naszej mocy, aby zminimalizować czas naprawy. Radzimy skontaktować się bezpośrednio z serwisem sportowym wybranego sklepu Decathlon, aby uzyskać szacunkowy czas naprawy.',
          p3: 'Tu znajdzie Pan/i najbliższy serwis sportowy Decathlon:',
          decathlonLocatorLink: 'https://www.decathlon.fr/store-locator',
          p4: 'Poniżej znajduje się "Instrukcja naprawy dla klienta", którą należy okazać naszemu serwisantowi w serwisie sportowym:',
          p5: 'Aby uzyskać więcej informacji, prosimy o kontakt z naszym Centrum Obsługi Klienta, które jest do Państwa dyspozycji pod numerem: 800808007, czynne od poniedziałku do piątku w godzinach od 09:00 do 19:00, w soboty i niedziele od 09.00 do 17.00 oraz mailowo: kontakt@decathlon.pl.',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Jak znaleźć numer identyfikacyjny roweru:',
      description:
        '30-cyfrowy numer jest wydrukowany na spodzie ramy roweru, w pobliżu dolnego suportu i pedałów. Spójrz na poniższe zdjęcie.',
    },
  },
}

export default pl
